import * as React from "react";

import { FullPageErrorModal } from "@v1/components/editor/page/FullPageErrorModal";
import EmptyLayout from "@v1/layouts/EmptyLayout";
import { useSearchParams } from "react-router-dom";
import { z } from "zod";

const ShopifyInstalledOnNoAccessWorkspaceLayout = () => {
  const [searchParams] = useSearchParams();
  const intendedHostingType =
    z
      .enum(["shopify", "replo"])
      .safeParse(searchParams.get("intendedHostingType")).data ?? "replo";
  return (
    <EmptyLayout>
      <FullPageErrorModal
        isClosable={false}
        details={{
          header: `Cannot add ${intendedHostingType === "shopify" ? "Theme Builder" : "AI Builder"} shop`,
          subheader:
            "This Shopify store is used for billing on your Replo workspace.",
          message: `Since the billing for your workspace is tied to your Shopify store, Replo can't add a new shop linked to the same Shopify store. In order to use the ${intendedHostingType === "shopify" ? "Theme Builder" : "AI Builder"} with the same Shopify store, please reach out to support@replo.app to manage your billing plan.`,
          callToAction: {
            type: "navigate",
            location: { type: "home" },
          },
        }}
      />
    </EmptyLayout>
  );
};

export default ShopifyInstalledOnNoAccessWorkspaceLayout;
